export default __webpack_public_path__ + "static/media/calender-icon.78023ace.svg";